//客服中心-首页
Vue.component(
    'contact-index',
    resolve => require(["../../components/contact/index"], resolve)
);
//客服中心-头部
Vue.component(
    'contact-header',
    resolve => require(["../../components/contact/header"], resolve)
);
//客服中心-咨询
Vue.component(
    'contact-consult',
    resolve => require(["../../components/contact/consult"], resolve)
);
//客服中心-提交成功
Vue.component(
    'contact-success',
    resolve => require(["../../components/contact/success"], resolve)
);

//客服中心-留言
Vue.component(
    'contact-message',
    resolve => require(["../../components/contact/message"], resolve)
);
//客服中心-提现
Vue.component(
    'contact-withdraw',
    resolve => require(["../../components/contact/withdraw"], resolve)
);
//客服中心-开发中弹窗
Vue.component(
    'contact-developing',
    resolve => require(["../../components/contact/developing"], resolve)
);



// WEBPACK FOOTER //
// ./resources/js/signCom/module/contact.js